import { ENG, CH } from "../../constants"

let dictionary = {}

dictionary[ENG] = {
    TITLE: "Skill"
}

dictionary[CH] = {
    TITLE: "專業技能"
}

export default dictionary
